import { useSnackbar } from 'notistack';
import { hasForbiddenPasswordCharacters, PASSWORD_CHARACTER_CONSTRAINTS } from '../../utils/passwordPolicy';

const usePasswordInputGuard = () => {
  const { enqueueSnackbar } = useSnackbar();
  const warn = () => enqueueSnackbar(PASSWORD_CHARACTER_CONSTRAINTS, { variant: 'error', preventDuplicate: true });

  const changePassword = (setter, value) => {
    if (hasForbiddenPasswordCharacters(value)) {
      warn();
      return;
    }
    setter(value);
  };

  const handlePasswordPaste = (event) => {
    if (hasForbiddenPasswordCharacters(event.clipboardData.getData('text'))) {
      event.preventDefault();
      warn();
    }
  };

  return { changePassword, handlePasswordPaste };
};

export default usePasswordInputGuard;
